import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRight } from 'lucide-react';
interface ButtonProps {
  children: React.ReactNode;
  subtext?: string;
  variant?: 'primary' | 'secondary' | 'outline';
  fullWidth?: boolean;
  icon?: boolean;
  className?: string;
  href?: string;
  onClick?: (e: React.MouseEvent) => void;
  pulse?: boolean;
  target?: string;
  rel?: string;
}
export function Button({
  children,
  subtext,
  variant = 'primary',
  fullWidth = false,
  icon = true,
  className = '',
  href,
  onClick,
  pulse = true,
  target,
  rel
}: ButtonProps) {
  const baseStyles = 'relative flex flex-col items-center justify-center px-8 py-5 rounded-2xl font-serif font-semibold text-lg md:text-xl transition-all overflow-hidden group cursor-pointer';
  const variants = {
    primary: 'bg-gradient-to-b from-olive to-olive-dark text-cream-light shadow-glow border border-gold/30',
    secondary: 'bg-cream-dark text-charcoal hover:bg-gold/10 border border-gold/20 shadow-soft',
    outline: 'bg-transparent border border-olive text-olive hover:bg-olive/5'
  };
  const widthClass = fullWidth ? 'w-full' : 'w-full md:w-auto';
  const pulseClass = pulse && variant === 'primary' ? 'animate-cta-pulse' : '';
  const content = <>
      {variant === 'primary' && <div className="absolute inset-1 border border-gold/20 rounded-xl pointer-events-none" data-id="element-480" />}
      <div className="flex items-center gap-3 relative z-10" data-id="element-481">
        <span className="tracking-wide" data-id="element-482">{children}</span>
        {icon && <ChevronRight className="w-5 h-5 group-hover:translate-x-1 transition-transform text-gold" data-id="element-483" />}
      </div>
      {subtext && <span className="text-sm font-sans font-light opacity-80 mt-1 tracking-wide relative z-10" data-id="element-484">
          {subtext}
        </span>}
      <div className="absolute inset-0 -translate-x-full group-hover:animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/10 to-transparent skew-x-12" data-id="element-485" />
    </>;
  const combinedClassName = `${baseStyles} ${variants[variant]} ${widthClass} ${pulseClass} ${className}`;
  if (href) {
    return <motion.a href={href} target={target} rel={rel} onClick={onClick} whileHover={{
      y: -2,
      scale: 1.01
    }} whileTap={{
      scale: 0.99
    }} className={combinedClassName} data-id="element-486">
        {content}
      </motion.a>;
  }
  return <motion.button onClick={onClick} whileHover={{
    y: -2,
    scale: 1.01
  }} whileTap={{
    scale: 0.99
  }} className={combinedClassName} data-id="element-487">
      {content}
    </motion.button>;
}